import React, { useMemo, useRef, useState, useCallback } from 'react';
import c from 'classnames';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { BiData } from '@wix/da-bi/pkg/events';
import ListMenu from '../../../Dropdown/Preset/ListMenu';
import { mobileSubmitMenuItems } from '../../constants';
import SubmitMenuItem from './SubmitMenuItem';
import { useOnOutsideClick } from '@wix/da-hooks/dist/src/useOnOutsideClick';
import s from './SubmitDropdown.scss';
var SubmitDropdown = function (_a) {
    var className = _a.className, menuClassName = _a.menuClassName, isLegacyHeader = _a.isLegacyHeader;
    var rootRef = useRef(null);
    var _b = useState(false), isOpen = _b[0], setOpen = _b[1];
    var closeMenu = useCallback(function () { return setOpen(false); }, []);
    useOnOutsideClick(rootRef, closeMenu);
    var submitMenuItems = useMemo(function () {
        return mobileSubmitMenuItems.map(function (_a) {
            var type = _a.type, label = _a.label, target = _a.target, _b = _a.verificationAction, verificationAction = _b === void 0 ? 'submit' : _b, link = _a.link, modalType = _a.modalType, modalOptions = _a.modalOptions, isNew = _a.isNew;
            return {
                key: label,
                renderElement: function () { return (React.createElement(SubmitMenuItem, { className: s['submit-menu-item'], type: type, modalType: modalType, modalOptions: modalOptions, label: label, link: link, target: target, verificationAction: verificationAction, isNew: isNew, isLegacyHeader: isLegacyHeader })); },
            };
        });
    }, [isLegacyHeader]);
    return (React.createElement("div", { className: c(s['root'], className), ref: rootRef },
        React.createElement(BrandedButton, { variant: "brand-green", size: "medium", className: s['button'], onClick: function () { return setOpen(function (open) { return !open; }); }, biData: isOpen
                ? undefined
                : BiData({
                    evid: 703,
                    sectionname: 'dropdown',
                }) },
            React.createElement(AddIcon, { className: s['icon'], size: IconSize.MEDIUM, disableDefaultColors: true })),
        isOpen && (React.createElement(ListMenu, { className: c(s['menu'], menuClassName), items: submitMenuItems }))));
};
SubmitDropdown.displayName = 'SubmitDropdown';
export default SubmitDropdown;
//# sourceMappingURL=SubmitDropdown.js.map